export const SITE = {
  name: "Borås Fritid",
  owner: "Anthoni Hagert",
  phone: "+46720200996",
  phoneDisplay: "+46 72 020 09 96",
  address: "Viaredsvägen 43E",
  zip: "504 64 Borås",
  orgnr: "010305-8970",
  fskatt: "Godkänd för F-skattsedel",
  logo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_ec692efa-ce3d-4a79-8203-bdf92352d3d6/artifacts/evwbm0x2_IMG_0485-removebg-preview.png",
  mapsEmbed:
    "https://www.google.com/maps?q=Viaredsv%C3%A4gen+43E,+504+64+Bor%C3%A5s&output=embed",
  mapsDirections:
    "https://www.google.com/maps/dir/?api=1&destination=Viaredsv%C3%A4gen+43E,+504+64+Bor%C3%A5s",
};

export const HERO_IMAGE =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_husvagn-hub/artifacts/1e279a4f96d3feb8_dscf5697-imperial-810-lgb-1-1024x731.jpg";
export const ABOUT_IMAGE =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_husvagn-hub/artifacts/1e279a4f96d3feb8_dscf5697-imperial-810-lgb-1-1024x731.jpg";
export const INTERIOR_IMAGE =
  "https://images.unsplash.com/photo-1684392523178-22af9756866c?crop=entropy&cs=srgb&fm=jpg&q=85";

export const formatPrice = (n) => `${new Intl.NumberFormat("sv-SE").format(n)} kr`;

export const statusLabel = (s) => (s === "salt" ? "Såld" : "Tillgänglig");
export const typeLabel = (t) => (t === "husvagn" ? "Husvagn" : "Husbil");
